import { TermCourseQuery } from '../../queries/term_courses_query';

class TermCoursesController {
  constructor(private ngTermCourseQuery: TermCourseQuery) {}
}
class TermCoursesComponent implements ng.IComponentOptions {
  public templateUrl: string =
    'capability-ng-scheduler/src/views/term_courses/components/term_courses_list/term_courses_list.html';
  public controller = TermCoursesController;
}
angular.module('capability-ng-scheduler').component('termCoursesList', new TermCoursesComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/term_courses/components/term_courses_list/term_courses_list_component.ts